
import React from 'react';
import { Award, Calendar, Trophy } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import ProgressBar from '@/components/ui/ProgressBar';

interface AchievementsTabProps {
  streak: number;
  wordsLearned: number;
  totalXP: number;
}

const AchievementsTab: React.FC<AchievementsTabProps> = ({
  streak,
  wordsLearned,
  totalXP
}) => {
  const achievements = [
    { 
      title: '5 Day Streak', 
      description: 'Learn for 5 days in a row',
      progress: Math.min((streak / 5) * 100, 100),
      icon: <Calendar className="h-5 w-5 text-orange-500" />,
      date: streak >= 5 ? 'Completed' : 'In progress'
    },
    { 
      title: 'Word Collector', 
      description: 'Learn 50 new words',
      progress: Math.min((wordsLearned / 50) * 100, 100),
      icon: <Award className="h-5 w-5 text-primary" />,
      date: wordsLearned >= 50 ? 'Completed' : 'In progress'
    },
    { 
      title: 'XP Hunter', 
      description: 'Earn 1000 XP',
      progress: Math.min((totalXP / 1000) * 100, 100),
      icon: <Trophy className="h-5 w-5 text-yellow-400" />,
      date: totalXP >= 1000 ? 'Completed' : 'In progress'
    },
  ];

  return (
    <div className="space-y-4 animate-fade-in">
      {achievements.map((achievement, index) => (
        <Card key={index} className="overflow-hidden border-none shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="p-0">
            <div className="p-4">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-full bg-muted flex items-center justify-center shrink-0">
                  {achievement.icon}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between">
                    <h3 className="font-medium">{achievement.title}</h3>
                    <span className="text-xs text-muted-foreground">{achievement.date}</span>
                  </div>
                  <p className="text-sm text-muted-foreground">{achievement.description}</p>
                  <ProgressBar 
                    value={achievement.progress} 
                    max={100} 
                    size="sm"
                    className="mt-2" 
                  />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AchievementsTab;
